import { locale } from 'moment';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClient } from './http-client';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ABMRolesService {
    private tmpAcopio;
    private tmpCategoria;

    constructor(private httpClient: HttpClient,
                private router: Router) {

    }

    getRoles(){
      return this.httpClient.get(`/api/roles/`)
         .map((response: Response) => {
           if (response){
             return response.json().ResponseData;
           }
      });
    }

    getRol(rolId) {
      return this.httpClient.get(`/api/rol/${rolId}`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    getRolesFiltered(cuentasIds = [], categoriasIds = [], colaboradoresIds = []){

      let request = {
        CuentasId: cuentasIds,
        ColaboradoresId: colaboradoresIds,
        CategoriasId: categoriasIds
      };

      return this.httpClient.post(`/api/roles/categorias/`, request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    createRol(nombre: string, categorias, acopios, empresas, colaboradores, permisoId, visibleClientes){
      let request = {
        RolName: nombre,
        Categorias: categorias,
        Acopios: acopios,
        Empresas: empresas,
        Colaboradores: colaboradores,
        CurrentUserId: localStorage.getItem('userId'),
        FullView: false,
        MesaNegocio: false,
        ProductosVisibles: null,
        Autorizante: false,
        PublicadorPrecio: false,
        PermisoId: permisoId,
        VisibleClientes: visibleClientes
      };

      return this.httpClient.post(`/api/roles/`, request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    updateRol(id, nombre: string, categorias, acopios, empresas, colaboradores, empresasToAdd, empresasToRemove, permisoId, visibleClientes) {
      let request = {
        RolName: nombre,
        Categorias: categorias,
        Acopios: acopios,
        Empresas: empresas,
        EmpresasToAdd: empresasToAdd,
        EmpresasToRemove: empresasToRemove,
        Colaboradores: colaboradores,
        CurrentUserId: localStorage.getItem('userId'),
        FullView: false,
        MesaNegocio: false,
        Id: id,
        ProductosVisibles: null,
        Autorizante: false,
        PublicadorPrecio: false,
        PermisoId: permisoId,
        VisibleClientes: visibleClientes
      };

      return this.httpClient.put(`/api/roles/`, request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    getCategorias() {
      return this.httpClient.get(`/api/roles/categorias`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    getAcopios() {
      return this.httpClient.get(`/api/roles/acopios/all`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    getAcopioById(id) {
      return this.httpClient.get(`/api/acopios/${id}`)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    getProductos() {
      return this.httpClient.get(`/api/roles/productos`)
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    }

    createProducto(datos) {
      return this.httpClient.post(`/api/producto`, datos)
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    }

    editProducto(datos) {
      return this.httpClient.put(`/api/producto`, datos)
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    }

    deleteProducto(datos: number) {
      return this.httpClient.delete(`/api/producto/${datos}`)
        .map((response: Response) => {
          if (response) {
            return response.json().ResponseData;
          }
        });
    }

    getCuentasByAcopiosIds(acopiosIds) {
      let request = {
        AcopiosId: acopiosIds
      };
      return this.httpClient.post('/api/roles/cuentas/', request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      })
    }

    filterAcopios(cuentasIds = [], colaboradoresIds = [], categoriasIds = []) {

      let request = {
        CuentasId: cuentasIds,
        ColaboradoresId: colaboradoresIds,
        CategoriasId: categoriasIds
      };

      return this.httpClient.post(`/api/roles/acopios/`, request)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    activateRol(rolId) {
      return Observable.from([{
        ResponseData: {

        }
      }]);
    }

    activateAcopio(acopioId){
      return Observable.from([{
        ResponseData: {

        }
      }]);
    }

    updatePlanComercial(acopioId, visibility) {
      return this.httpClient.put(`/api/acopios/${acopioId}/plan-comercial-visible/${visibility}`, undefined)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      }); 
    }

    activateCategoria(categoriaId){
      return Observable.from([{
        ResponseData: {

        }
      }]);
    }

    createAcopio(acopio){
      return this.httpClient.post(`/api/acopios/`, acopio)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    updateAcopio(acopio){
      return this.httpClient.put(`/api/acopios/`, acopio)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    setAcopioCentral(id: number, acopio){
      return this.httpClient.post(`/api/acopios/${id}/set-central`, acopio)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    setTmpAcopio(acopio) {
      this.tmpAcopio = acopio;
    }

    getTmpAcopio() {
      return this.tmpAcopio;
    }

    createCategoria(categoria){
      return this.httpClient.post(`/api/categorias/`, categoria)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    updateCategoria(categoria){
      return this.httpClient.put(`/api/categorias/`, categoria)
        .map((response: Response) => {
          if (response){
            return response.json().ResponseData;
          }
      });
    }

    setTmpCategoria(categoria) {
      this.tmpCategoria = categoria;
    }

    getTmpCategoria() {
      return this.tmpCategoria;
    }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/abm-roles-service.ts